<div class="close">
  <button mat-dialog-close>
    <img
      alt="close"
      width="24"
      height="24"
      src="../../../../assets/images/close.svg"
    />
  </button>
</div>
<div class="title">选择不可用订阅的补偿计划</div>
<div class="content" mat-dialog-content>
  <div class="subtitle1">
    检测到您的家庭组存在异常，请选择以下一种解决方案：
  </div>
  <div class="tabs">
    <div
      class="tab"
      (click)="changeIndex(1)"
      [ngClass]="{ active: index === 1 }"
    >
      等待修复 (推荐)<img
        src="../../../../assets/images/compensate/recommend.webp"
        alt=""
      />
    </div>
    <!-- <div
      class="tab"
      (click)="changeIndex(2)"
      [ngClass]="{ active: index === 2 }"
    >
      钱包退款
    </div> -->
  </div>
  <div class="subtitle2">尝试修复，若失败可【换号】</div>
</div>
<div class="button" [ngClass]="{ active: index === 1 }">
  <button matRipple style="background: #00ad9d" (click)="waitRepairTime()">
    确认
  </button>
</div>
<div class="button" [ngClass]="{ active: index === 2 }">
  <button matRipple style="background: #00ad9d" (click)="refund()">确认</button>
</div>
